/*
 * Picture viewer: any element with data-fwl-zoom="<large image url>" opens that picture full screen.
 * Pictures sharing data-fwl-zoom-group can be stepped through with arrows, swipes or arrow keys.
 * Tap/click the picture to zoom in (move the mouse or drag to look around); tap again to zoom out.
 * Loaded by the landing sections; safe to include more than once.
 */
(function () {
  if (window.fwlLightbox) return;
  window.fwlLightbox = true;

  var ZOOM = 2.5;
  var box, stage, img, counter, prevBtn, nextBtn, items = [], index = 0, zoomed = false, lastFocus = null;

  function build() {
    box = document.createElement('div');
    box.className = 'fwl-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Enlarged picture');
    box.hidden = true;
    box.innerHTML =
      '<button type="button" class="fwl-lightbox__close" aria-label="Close">&times;</button>' +
      '<button type="button" class="fwl-lightbox__nav fwl-lightbox__nav--prev" aria-label="Previous picture">&#8249;</button>' +
      '<div class="fwl-lightbox__stage"><img class="fwl-lightbox__img" alt=""></div>' +
      '<button type="button" class="fwl-lightbox__nav fwl-lightbox__nav--next" aria-label="Next picture">&#8250;</button>' +
      '<p class="fwl-lightbox__hint"><span data-counter></span><span class="fwl-lightbox__tip">Tap the picture to zoom</span></p>';
    document.body.appendChild(box);
    stage = box.querySelector('.fwl-lightbox__stage');
    img = box.querySelector('.fwl-lightbox__img');
    counter = box.querySelector('[data-counter]');
    prevBtn = box.querySelector('.fwl-lightbox__nav--prev');
    nextBtn = box.querySelector('.fwl-lightbox__nav--next');

    box.querySelector('.fwl-lightbox__close').addEventListener('click', close);
    prevBtn.addEventListener('click', function () { show(index - 1); });
    nextBtn.addEventListener('click', function () { show(index + 1); });

    // Clicking the dark area (not the picture or a button) closes.
    box.addEventListener('click', function (event) {
      if (event.target === box || event.target === stage) close();
    });

    img.addEventListener('click', function (event) {
      setZoom(!zoomed, event.clientX, event.clientY);
    });

    // Desktop: when zoomed, the picture follows the mouse.
    stage.addEventListener('mousemove', function (event) {
      if (!zoomed || event.buttons) return;
      var rect = stage.getBoundingClientRect();
      stage.scrollLeft = (stage.scrollWidth - rect.width) * ((event.clientX - rect.left) / rect.width);
      stage.scrollTop = (stage.scrollHeight - rect.height) * ((event.clientY - rect.top) / rect.height);
    });

    // Phones: swipe left/right to change pictures when not zoomed (zoomed, a drag pans instead).
    var startX = null, startY = null;
    stage.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) { startX = null; return; }
      startX = event.touches[0].clientX; startY = event.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (event) {
      if (startX === null || zoomed) return;
      var dx = event.changedTouches[0].clientX - startX;
      var dy = event.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
      startX = null;
    });

    document.addEventListener('keydown', function (event) {
      if (box.hidden) return;
      if (event.key === 'Escape') close();
      else if (event.key === 'ArrowLeft') show(index - 1);
      else if (event.key === 'ArrowRight') show(index + 1);
    });
  }

  function setZoom(on, x, y) {
    // Measure the picture as shown before zooming changes the layout.
    var shown = img.getBoundingClientRect();
    zoomed = on;
    box.classList.toggle('is-zoomed', on);
    if (!on) { img.style.width = ''; img.style.height = ''; return; }
    var rect = stage.getBoundingClientRect();
    var fx = shown.width ? (x - shown.left) / shown.width : 0.5;
    var fy = shown.height ? (y - shown.top) / shown.height : 0.5;
    img.style.width = shown.width * ZOOM + 'px';
    img.style.height = shown.height * ZOOM + 'px';
    // Keep the spot that was tapped under the finger/cursor.
    stage.scrollLeft = img.offsetLeft + fx * shown.width * ZOOM - (x - rect.left);
    stage.scrollTop = img.offsetTop + fy * shown.height * ZOOM - (y - rect.top);
  }

  function show(i) {
    if (!items.length) return;
    index = (i + items.length) % items.length;
    setZoom(false);
    var item = items[index];
    var thumb = item.querySelector('img');
    img.src = item.getAttribute('data-fwl-zoom');
    img.alt = (thumb && thumb.alt) || '';
    var many = items.length > 1;
    prevBtn.hidden = !many;
    nextBtn.hidden = !many;
    counter.textContent = many ? (index + 1) + ' / ' + items.length : '';
  }

  function open(trigger) {
    if (!box) build();
    var group = trigger.getAttribute('data-fwl-zoom-group');
    items = group
      ? [].slice.call(document.querySelectorAll('[data-fwl-zoom-group="' + group + '"]'))
      : [trigger];
    lastFocus = trigger;
    box.hidden = false;
    document.documentElement.classList.add('fwl-lightbox-open');
    show(Math.max(0, items.indexOf(trigger)));
    box.querySelector('.fwl-lightbox__close').focus();
    try { if (window.clarity) window.clarity('event', 'picture_enlarged'); } catch (e) {}
  }

  function close() {
    setZoom(false);
    box.hidden = true;
    img.removeAttribute('src');
    document.documentElement.classList.remove('fwl-lightbox-open');
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-fwl-zoom]');
    if (!trigger) return;
    event.preventDefault();
    open(trigger);
  });
})();
